import React, { useState, useEffect, useContext } from 'react';
import { StoreContext } from '../Store/StoreProvider';
//import { types } from '../Store/storeReducer';
import { 
    AppBar,
    Button, 
    Checkbox,
    Chip,
    Dialog,
    Fab,
    Grid,
    IconButton,
    MuiThemeProvider,
    Paper,
    Slide,
    TextField,
    Toolbar,
    Tooltip as TooltipMaterial,
    Typography,
} from '@material-ui/core';
// import { DataGrid  } from '@material-ui/data-grid';
import { 
    AttachMoney as AttachMoneyIcon,
    CheckBox as CheckBoxIcon,
    CheckBoxOutlineBlank as CheckBoxOutlineBlankIcon,
    Close as CloseIcon,
    ListAlt as ListAltIcon,
    Refresh as RefreshIcon,
    Settings as SettingsIcon,
    TrendingUp as TrendingUpIcon,
} from '@material-ui/icons';
import { Autocomplete, Alert } from '@material-ui/lab';
import { makeStyles, createTheme } from '@material-ui/core/styles';
import { useAuth } from "../Auth";
import { Pie } from 'react-chartjs-2';
import { Chart, ArcElement, Tooltip, Legend } from 'chart.js'
import withWidth from '@material-ui/core/withWidth';
import  FacebookCircularProgress  from '../Elementos/FacebookCircularProgress';
import {
    FilteringState,
    IntegratedSorting,
    IntegratedFiltering,
    SortingState,
    PagingState,
    IntegratedPaging,
  } from '@devexpress/dx-react-grid';
import {
    Grid as XGrid,
    DragDropProvider,
    Table,
    TableHeaderRow,
    TableColumnReordering,
    TableColumnResizing,
    TableFilterRow,
    PagingPanel,
  } from '@devexpress/dx-react-grid-material-ui';
import { 
    DatePicker,
    Modal as ModalAntd, 
    Space, 
    Spin,
    Switch as SwitchAntd
} from 'antd';

Chart.register(ArcElement, Tooltip, Legend);
const { RangePicker } = DatePicker;

const useStyles = makeStyles((theme) => ({
    menuButton: {
      marginRight: theme.spacing(2),
    },
    title: {
      flexGrow: 1,
    },
    button:{
        marginTop:2
    },
    paper_1:{
        marginTop:10,
        width:'100%',
        padding:10,
        minHeight:500,
        height:520,
        overflowY:'auto',
        overflowX:'hidden',
    },
    table: {
        minWidth: 650,
      },
}));

const Meses = [
    {Nombre:'Enero', Numero:1},{Nombre:'Febrero', Numero:2},{Nombre:'Marzo', Numero:3},{Nombre:'Abril', Numero:4},
    {Nombre:'Mayo', Numero:5},{Nombre:'Junio', Numero:6},{Nombre:'Julio', Numero:7},{Nombre:'Agosto', Numero:8},
    {Nombre:'Septiembre', Numero:9},{Nombre:'Octubre', Numero:10},{Nombre:'Noviembre', Numero:11},{Nombre:'Diciembre', Numero:12},
];

const arrMeses2 = ['', 'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];

const moment = require('moment-timezone');
const laZona="America/Guayaquil";

const ThemeTextField = createTheme({
    palette: {
      primary: {
        main: '#fff',
      },
      secondary: {
        main: '#fff',
      },
    },
});

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const columns = [
    { name: 'Nombres', title: 'Cliente' },
    { name: 'StatusPago', title: 'Status' },
    { name: 'ValTotal', title: 'Valor' },
];

const columns_ = [
    { name: 'NumberInvoice', title: '#' },
    { name: 'Nombres', title: 'Cliente' },
    { name: 'ValTotal', title: 'Valor' },
    { name: 'Zona', title: 'Zona' },
];

function Reporteria_Pagos ({width}){
    const classes = useStyles();
    const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
    const checkedIcon = <CheckBoxIcon fontSize="small" />;
    const [ { zonas, isReadyInfo, isReadyFacturas, facturas } ] = useContext(StoreContext)
    const { authTokens, ageWork, setRuta } = useAuth(); 
    const [ listMeses, setListMeses ] = useState(Meses);
    const [ mesSelected, setMesSelected ] = useState([]);
    const [ totalClientes, setTotalClientes] = useState([]);
    const [ valorPendiente, setValorPendiente ] = useState(0);
    const [ valorPagado, setValorPagado ] = useState(0);
    const [ valorTotal, setValorTotal ] = useState(0);
    const [ dataList, setDataList ] = useState(false);
    const [ dataChart, setDataChart ] = useState({});
    const [ showElement, setShowElement ] = useState(true);
    const [ showTable, setShowTable ] = useState(false);
    const [ isProcessing, setProcessing ] = useState(false);
    const [ showAlertMes, setShowAlertMes ] = useState(false);
    const [columnWidths, setColumnWidths] = useState([
        { columnName: 'Nombres', width: 320 },
        { columnName: 'StatusPago', width: 100 },
        { columnName: 'ValTotal', width: 100 },
    ]);
    const [columnWidths_, setColumnWidths_] = useState([
        { columnName: 'NumberInvoice', width:105 },
        { columnName: 'Nombres', width: 320 },
        { columnName: 'ValTotal', width: 85 },
        { columnName: 'Zona', width: 165 },
    ]);
    const [sorting, setSorting] = useState([{ columnName: 'Nombres', direction: 'asc' }]);
    const [ zonaSelected, setZonaSelected ] = useState([]);
    const [ isReady, setReadyInfo ] = useState(false);
    const [ dataZona, setDataZona ] = useState([]);
    const [ isClientActive, setClientActive ] = useState(false);
    const [ getInToday, setInToday ] = useState([]);
    const [ getTotalToday, setTotalToday ] = useState('');
    const [ isNewCalculo, setNewCalculo ] = useState(false);
    const [ getCalculoNew, setCalculoNew ] = useState('');
    const [ getCalculoArr, setCalculoArr ] = useState([]);
    const [ getOpenMenu, setOpenMenu ] = useState(false);
    const [ getFecRec, setFecRec ] = useState('');
    const [ isRango, setRango ] = useState(false);
    const [ getRangoDate, setRangoDate ] = useState([
        moment(), moment()
    ])

    useEffect(()=>{
        async function ReqInfo() {
            if(authTokens.Zonas.length > 0) setZonaSelected(authTokens.Zonas.map(el=> el.Zona));
            const laFecha = moment().tz(laZona).format();
            const arrMonth = [];
            arrMonth.push(arrMeses2[parseInt(laFecha.split('-')[1], 10)]);
            setMesSelected(arrMonth);
            setListMeses(Meses);
            setRuta('/Reporteria/Pagos')
        };
    
        ReqInfo();
    },[]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(()=>{
        switch(width){
            case 'xl': setShowElement(true); break;
            case 'lg': setShowElement(true); break;
            case 'md': setShowElement(true); break;
            case 'sm': setShowElement(false); break;
            case 'xs': setShowElement(false); break;
            default: setShowElement(false); break;
        }
    },[width]) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(
        ()=>{  
            if(isReadyInfo){ 

                authTokens.Type === 'ADMINISTRADOR' ? (()=>{
                    setDataZona(zonas);
                    setReadyInfo(true);
                })()   : (()=>{   
                    const ZonasArr = authTokens.Zonas.map(valZon=> valZon.Zona);
                    const arrFilZona = zonas.filter(value=> ZonasArr.includes(value.Zona.toString()));
                    setDataZona(arrFilZona); 
                    setReadyInfo(true);
                })()
                
                
            }
        },[isReadyInfo] // eslint-disable-line react-hooks/exhaustive-deps
    );

    useEffect(()=>{
        if(isReadyFacturas){         
            const laFecha = moment().tz(laZona).format();
            const arr = facturas.filter(el=> laFecha.split('T')[0].toString() === el.Registro.split('T')[0].toString()).filter(el=> zonaSelected.includes(el.Zona));
            let valToday = 0;
            for(const x in arr){
                valToday = parseFloat( arr[x].ValTotal) + parseFloat( valToday);
            }
            setInToday(arr);
            setTotalToday(parseFloat(valToday).toFixed(2));
        }
    },[isReadyFacturas, facturas, zonaSelected])

    const HandleSelectName = (value)=>{
        setMesSelected(value);
    }; 

    const HandleReset = ()=>{
        setMesSelected([]);
        setDataList(false);
        setValorPendiente(0);
        setValorPagado(0);
        setValorTotal(0);
        setTotalClientes([]);
        setProcessing(false);
    };

    const HandleProcesar = async ()=>{
        setProcessing(true);
        if(mesSelected.length === 0){
            setShowAlertMes(true);
            setTimeout(()=>{
                setProcessing(false);
                setTimeout(()=>{
                    setShowAlertMes(false);
                },8000)
            },1000)
        }else{
            fetch('/api/pagos/reporte',{ 
                method:'POST', 
                body: JSON.stringify({Meses:mesSelected, ageWork, Zonas:zonaSelected, clientActive:isClientActive}),                    
                headers:{
                    'Content-Type': 'application/json'
                }
            }).then(response=>response.json())
            .then(result=>{
                console.log(result.map(el=> el.Status))
                console.log(result.map(el=> el.ValPlan))
                const arrPagados = [];
                const arrPendientes =  [];
                const arrTotal = [];
                let valPendiente = 0;
                let valPagado = 0;
                let valTotal = 0;
                for(const x in result){
                    const objeto = {...result[x]};
                    objeto.StatusPago = result[x].Status;
                    objeto.id = result[x]._id;
                    arrTotal.push(objeto);
                    valTotal += parseInt(result[x].ValPlan);
                    if(result[x].Status === 'Pagado'){
                        arrPagados.push(objeto);
                        valPagado += parseInt(result[x].ValPlan);
                    }else if(result[x].Status === 'Pendiente'){
                        arrPendientes.push(objeto);
                        valPendiente += parseInt(result[x].ValPlan);
                    }else{
                        arrPendientes.push(objeto);
                    }
                };
                setTotalClientes(arrTotal);
                setValorPendiente(valPendiente);
                setValorPagado(valPagado);
                setValorTotal(valTotal);    
                setDataChart({
                    labels:['$Pagados', '$Pendientes'],
                    datasets: [
                        {
                        label: '# of Clientes',
                        data: [valPagado, valPendiente],
                        backgroundColor: [
                            'rgb(54, 162, 235)',
                            'rgb(255, 99, 132)',
                        ],
                        hoverOffset: 4
                        },
                    ],
                });
                setTimeout(()=>{
                    setDataList(true);
                    setProcessing(false);
                },1000)
            })
            
        }
    };

    const HandleShowTable = ()=>{
        setShowTable(true);
    };

    const HandleCloseDialog = ()=>{
        setShowTable(false);
    };

    const HandleCloseAlertMes = ()=>{
        setShowAlertMes(false);
    };

    const handleClearZona = ()=>{
        setZonaSelected([]);
        
    };

    const handleSelectZona = (valZ)=>{
        setZonaSelected(valZ);
    };

    const handleOpenCalculoNew = ()=>{
        const laFecha = moment().tz(laZona).format();
        setFecRec(laFecha.split('T')[0]);
        setOpenMenu(true);
    }

    const handleCalcularRecaudacion = ()=>{
        if(isRango){
            const arr = [...facturas];
            const arr_0 = [];
            const datI = new Date ( getRangoDate[0] );
            const datF = new Date ( getRangoDate[1] );
            for ( const x in arr){
                const datX_ = arr[x];
                const datX = new Date ( datX_.Registro.split('T')[0] );
                if( datX >= datI && datX <= datF) arr_0.push(datX_);
            };
            const arr_ = arr_0.filter(el=> zonaSelected.includes(el.Zona) );
            let valToday = 0;
            for(const x in arr_){
                valToday = parseFloat( arr_[x].ValTotal) + parseFloat( valToday);
            }
            setCalculoArr(arr_);
            setCalculoNew(parseFloat(valToday).toFixed(2));
            setNewCalculo(true);
            setOpenMenu(false);
        }else{
            if(getFecRec === ''){
                alert('DEBE SELECCIONAR UNA FECHA');
            }else{
                const arr = facturas.filter(el=> zonaSelected.includes(el.Zona)).filter(el=> el.Registro.split('T')[0].toString() === getFecRec.toString() );
                let valToday = 0;
                for(const x in arr){
                    valToday = parseFloat( arr[x].ValTotal) + parseFloat( valToday);
                }
                setCalculoArr(arr);
                setCalculoNew(parseFloat(valToday).toFixed(2));
                setNewCalculo(true);
                setOpenMenu(false);
            }
        }
    };

    const handleResetCalculoNew = ()=>{
        const laFecha = moment().tz(laZona).format();
        setCalculoArr([]);
        setCalculoNew('');
        setNewCalculo(false);
        setFecRec(laFecha.split('T')[0]);
    };

    const handleRango = (checked)=>{
        setRango(checked);
    };

    const handleSelectRango = (dates, datesString)=>{
        if(dates === null){
            const laFecha = moment().tz(laZona).format();
            setRangoDate([ laFecha.split('T')[0], laFecha.split('T')[0]])
        }else{
            setRangoDate(datesString)
        }
        
    };
    
    const handleCloseMenu = ()=>{
        const laFecha = moment().tz(laZona).format();
        setOpenMenu(false);
        setRango(false);
        setRangoDate([ laFecha.split('T')[0], laFecha.split('T')[0]]);
        setCalculoArr([]);
        setCalculoNew('');
        setNewCalculo(false);
        setFecRec(laFecha.split('T')[0]);
    }

    

    return(
        <Grid 
            container 
            justifyContent='center' 
            spacing={2}
            style={{
                marginTop:10,
                width:'99.5%',
                height:'90vh',
                overflow:'auto'
            }}
        >
            <Dialog fullScreen open={showTable} onClose={HandleCloseDialog} TransitionComponent={Transition}>
                <AppBar className={classes.appBar}>
                    <Toolbar>
                        <IconButton edge="start" color="inherit" onClick={HandleCloseDialog} aria-label="close">
                            <CloseIcon />
                        </IconButton>
                        <Typography variant="h6" className={classes.title}>
                            Clientes
                        </Typography>
                    </Toolbar>
                </AppBar>
                <Grid container style={{marginTop:50, height:'95vh', width:'100%'}} >
                    <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                        <XGrid rows={totalClientes} columns={columns} >
                            <DragDropProvider />  
                            <FilteringState defaultFilters={[]} />
                            <IntegratedFiltering />                   
                            <SortingState sorting={sorting} onSortingChange={setSorting} />
                            <IntegratedSorting />   
                            <PagingState defaultCurrentPage={0} pageSize={11} />
                            <IntegratedPaging />  
                            <Table />
                            <TableColumnResizing columnWidths={columnWidths} onColumnWidthsChange={setColumnWidths} />
                            <TableColumnReordering defaultOrder={['Nombres', 'StatusPago', 'ValTotal']}  />
                            <TableFilterRow />
                            <TableHeaderRow showSortingControls/>
                            <PagingPanel />
                        </XGrid>
                    </Grid>
                </Grid>
            </Dialog>
            <ModalAntd 
                title="OPCIONES DE RECAUDACION" 
                visible={ getOpenMenu } 
                onOk={ handleCalcularRecaudacion } 
                okText='OK'
                cancelText=''
                onCancel={ handleCloseMenu }
                cancelButtonProps={{ disabled:true }}
                bodyStyle={{ display:'flex', justifyContent:'center' }}
                destroyOnClose
                >
                    <Grid container justifyContent='center' spacing={2}>
                        <Grid item >
                            <SwitchAntd checkedChildren="RANGO" unCheckedChildren="DIA" checked={isRango} onChange={handleRango}/>
                        </Grid>
                        {
                            isRango ?
                            <Grid item xs={12}>
                                <RangePicker  
                                    value={ [ moment(getRangoDate[0], 'YYYY-MM-DD'), moment(getRangoDate[1],'YYYY-MM-DD')] || [ moment('YYYY-MM-DD'), moment('YYYY-MM-DD')] }
                                    onChange={handleSelectRango} 
                                    style={{width:'100%', marginTop:5}}
                                    
                                />
                            </Grid>:
                            <Grid item xs={12}>
                                <TextField
                                    autoFocus
                                    label='FECHA'
                                    fullWidth
                                    onChange={({target})=>{setFecRec(target.value);}}
                                    value={ getFecRec || ''}
                                    type='date'
                                    size='small'
                                    variant='outlined'                                    
                                />
                            </Grid>
                        }
                        
                    </Grid>
            </ModalAntd> 
            <Grid item 
                xs={12}
                style={{
                    backgroundColor:'OrangeRed',
                    height:'auto',
                    padding:20,
                    width:'100%',
                }}
            >             
                        <Grid 
                            alignItems='center'
                            container 
                            justifyContent='center' 
                            spacing={2} 
                        >
                            <Grid item md={6} xs={12}>
                                <MuiThemeProvider theme={ThemeTextField}>
                                    <Autocomplete
                                        multiple
                                        id="SelectionZones"
                                        options={dataZona.map(value=>value.Zona)}
                                        disableCloseOnSelect
                                        disabled={!isReady} 
                                        // getOptionLabel={(option) => option.title}
                                        renderOption={(option, { selected }) => (
                                            <React.Fragment>
                                            <Checkbox
                                                icon={icon}
                                                checkedIcon={checkedIcon}
                                                style={{ marginRight: 8 }}
                                                checked={selected}
                                            />
                                            {option}
                                            </React.Fragment>
                                        )}
                                        value={zonaSelected || ''}  
                                        onChange={(e,value, reason)=>{
                                            if(reason ===  'clear'){
                                                handleClearZona()
                                            }else{
                                                handleSelectZona(value);
                                            }
                                        }}  
                                        renderInput={(params) => (
                                            <TextField {...params} label="Zonas" variant="outlined" fullWidth color='primary'/>
                                        )}
                                    />
                                </MuiThemeProvider>
                            </Grid>
                            <Grid item md={6} xs={12}>
                                <MuiThemeProvider theme={ThemeTextField}>
                                    <Autocomplete
                                        multiple
                                        id="SelectionMonths"
                                        options={listMeses.map(value=>value.Nombre)}
                                        disableCloseOnSelect
                                        disabled={!isReady} 
                                        // getOptionLabel={(option) => option.title}
                                        renderOption={(option, { selected }) => (
                                            <React.Fragment>
                                            <Checkbox
                                                icon={icon}
                                                checkedIcon={checkedIcon}
                                                style={{ marginRight: 8 }}
                                                checked={selected}
                                            />
                                            {option}
                                            </React.Fragment>
                                        )}
                                        value={mesSelected || ''}  
                                        onChange={(e,value, reason)=>{
                                            if(reason ===  'clear'){
                                                HandleReset()
                                            }else{
                                                HandleSelectName(value);
                                            }
                                        }}  
                                        renderInput={(params) => (
                                            <TextField {...params} label="Meses" variant="outlined" fullWidth color='primary'/>
                                        )}
                                    />
                                </MuiThemeProvider>
                            </Grid>
                            {
                                showElement ?
                                <>
                                    <Grid item xl={2} lg={2} md={2} sm={4} xs={4}>
                                        <Checkbox
                                            value={isClientActive || false}
                                            onChange={({target})=>setClientActive(target.checked)}
                                            color='primary'
                                            style={{marginRight:1}}
                                        />
                                        <Chip
                                            label='CLIENTES ACTIVOS?'
                                        />
                                    </Grid>
                                    <Grid item xl={2} lg={2} md={2} sm={4} xs={4}>
                                        {
                                            isProcessing ?
                                            <Button variant="contained" color="primary" size="medium" style={{display:'flex', justifyContent:'center', alignItems:'center', paddingTop:8, width:130}} >
                                                <FacebookCircularProgress size={18} /> 
                                            </Button> :
                                            <Button variant="contained" color="primary" size="medium" endIcon={<TrendingUpIcon/>}  style={{paddingTop:5, width:130, padding:'7px 5px'}} onClick={HandleProcesar}>
                                                PROCESAR
                                            </Button>
                                        }
                                    </Grid>
                                    <Grid item xl={2} lg={2} md={2} sm={4} xs={4}>
                                        <Button variant="contained" color="primary" size="medium" endIcon={<ListAltIcon/>} className={classes.button} onClick={HandleShowTable} disabled={!dataList}>
                                            &nbsp; &nbsp; TABLA &nbsp;
                                        </Button>
                                    </Grid>
                                    <Grid item xl={2} lg={2} md={2} sm={4} xs={4}>
                                        <Button variant="contained" color="default" size="medium" endIcon={<RefreshIcon/>} className={classes.button} onClick={HandleReset} disabled={!dataList}>
                                            RESETEAR
                                        </Button>
                                    </Grid>
                                </>:
                                <>
                                    <Grid item md={1} sm={1} xs={2}>
                                        <TooltipMaterial  title='CLIENTES ACTIVOS?' arrow>
                                            <Checkbox
                                                value={isClientActive || false}
                                                onChange={({target})=>setClientActive(target.checked)}
                                                color='primary'
                                                style={{marginRight:1}}
                                            />
                                        </TooltipMaterial>
                                    </Grid>
                                    <Grid item xl={1} lg={1} md={1} sm={1} xs={2}>
                                        {
                                            isProcessing ?
                                            <FacebookCircularProgress size={35} /> :
                                            <Fab variant="round" color="primary"  size='small' onClick={HandleProcesar}>
                                                <TrendingUpIcon/>
                                            </Fab>
                                        }                              
                                    </Grid>
                                    <Grid item xl={1} lg={1} md={1} sm={1} xs={2}>
                                        
                                            <Fab variant="round" color="primary"  size='small' onClick={HandleShowTable} disabled={!dataList}>
                                                <ListAltIcon/>
                                            </Fab>
                                                                         
                                    </Grid>
                                    <Grid item xl={1} lg={1} md={1} sm={1} xs={2}>
                                        
                                            <Fab variant="round" color="default" onClick={HandleReset} size='small'  disabled={!dataList}>
                                                <RefreshIcon/>
                                            </Fab>
                                        
                                    </Grid>
                                </>
                            }
                        </Grid>
            </Grid>
            {
                showAlertMes &&
                <Grid item xs={12} style={{marginTop:10}}>
                    <Alert severity="error" onClose={HandleCloseAlertMes}>
                        Debe Seleccionar un Mes
                    </Alert>
                </Grid>
            }
            {
                width !== 'xs' &&
                <React.Fragment>         
                {
                    dataList ?
                    <Grid item md={6} xs={12} style={{marginTop:17}}>
                        <Paper elevation={3} square style={{minHeight:450, height:450}}>    
                            <Grid container spacing={2} justifyContent='center' style={{padding:5}} alignItems='center'>
                                <Grid item xl={4} lg={4} md={4} sm={4} xs={4}>
                                    <TextField 
                                        id='ValorTotal'
                                        fullWidth
                                        label='Total'
                                        value={valorTotal || ''}
                                        InputProps={{
                                            startAdornment: <AttachMoneyIcon color='primary'/>,
                                        }}
                                        variant='outlined'
                                        size='small'
                                    />
                                </Grid>
                                <Grid item xl={4} lg={4} md={4} sm={4} xs={4}>
                                    <TextField 
                                        id='ValorPendiente'
                                        fullWidth
                                        label='Pendiente'
                                        value={valorPendiente || ''}
                                        variant='outlined'
                                        size='small'
                                        InputProps={{
                                            startAdornment: <AttachMoneyIcon color='primary'/>,
                                        }}
                                    />
                                </Grid>
                                <Grid item xl={4} lg={4} md={4} sm={4} xs={4}>
                                    <TextField 
                                        id='ValorPagado'
                                        fullWidth
                                        label='Pagado'
                                        value={valorPagado || ''}
                                        variant='outlined'
                                        size='small'
                                        InputProps={{
                                            startAdornment: <AttachMoneyIcon color='primary'/>,
                                        }}
                                    />
                                </Grid>
                                <Grid item sm={5} xs={12}>
                                    <Pie data={dataChart} />
                                </Grid>
                            </Grid>        
                        </Paper>
                    </Grid> :
                    <Grid item md={6} style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                        <Space size="middle">
                            <Spin size="large" />
                        </Space>
                    </Grid>
                }
                </React.Fragment>
            }
            
            <Grid item md={6} xs={12}>
                <Paper 
                    elevation={3} 
                    square
                    style={{
                        marginTop:10,
                        width:'100%',
                        padding:10,
                        minHeight:450,
                        height:450,
                        overflowY:'auto',
                        overflowX:'hidden',
                    }}
                >
                    <Grid container style={{height:430, width:'100%', padding:5}} spacing={1} >
                        <Grid item xs={12}>
                            <Grid container spacing={2} justifyContent='space-between'>
                                <Grid item md={4} xs={6}>
                                    <TextField 
                                        id='ValToday'
                                        fullWidth
                                        label='Recaudado Hoy'
                                        value={ getTotalToday || '' }
                                        variant='outlined'
                                        size='small'
                                        InputProps={{
                                            startAdornment: <AttachMoneyIcon color='primary'/>,
                                        }}
                                    />
                                </Grid>
                                {
                                    isNewCalculo ?
                                    <Grid item md={4} xs={6}>
                                        <TextField 
                                            id='ValNewCalculo'
                                            fullWidth
                                            label='Total Recaudado'
                                            value={ getCalculoNew || '' }
                                            variant='outlined'
                                            size='small'
                                            InputProps={{
                                                startAdornment: <AttachMoneyIcon color='primary'/>,
                                            }}
                                        />
                                    </Grid> : null
                                }
                                <Grid item >
                                    <Grid container justifyContent='center'>
                                        <Grid item>
                                            <IconButton 
                                                color='primary' 
                                                onClick={ handleOpenCalculoNew }                                      
                                            >                            
                                                <SettingsIcon />
                                            </IconButton>
                                        </Grid>
                                        {
                                            isNewCalculo ?
                                            <Grid item >
                                                <IconButton 
                                                    color='primary' 
                                                    onClick={ handleResetCalculoNew }                                      
                                                >                            
                                                    <RefreshIcon />
                                                </IconButton>
                                            </Grid>:null
                                        }
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <XGrid rows={ isNewCalculo ? getCalculoArr : getInToday } columns={ columns_ } >
                                <DragDropProvider />  
                                <FilteringState defaultFilters={[]} />
                                <IntegratedFiltering />                   
                                <SortingState sorting={sorting} onSortingChange={setSorting} />
                                <IntegratedSorting />   
                                <PagingState defaultCurrentPage={0} pageSize={5} />
                                <IntegratedPaging />  
                                <Table />
                                <TableColumnResizing columnWidths={ columnWidths_ } onColumnWidthsChange={ setColumnWidths_ } />
                                <TableColumnReordering defaultOrder={['#','Nombres', 'ValTotal', 'Zona']}  />
                                <TableFilterRow />
                                <TableHeaderRow showSortingControls/>
                                <PagingPanel />
                            </XGrid>
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>
        </Grid>
    );
};

export default withWidth()(Reporteria_Pagos);